export default __webpack_public_path__ + "static/media/gallery_00.8b348cc5.jpg";